<template>
<div class="home">
    <div class="d-sm-flex align-items-center justify-content-between mb-3">
        <h1 class="h3 mb-0 text-gray-800">Dashboard <br/>
        </h1>            <small>(Jobs created before July 2023 will only shown in Archive) </small>
        <div>
            <div style="display: inline-block;" class="custom-control custom-checkbox small mr-3">
                <input v-model="showStats" @change="showStatsChange($event)" type="checkbox" class="custom-control-input" id="showStats" />
                <label class="custom-control-label" for="showStats">Show Stats</label>
            </div>
            <router-link to="/create-job" class="d-none d-sm-inline-block btn btn-primary shadow-sm"><i class="fas fa-plus fa-sm text-white-50"></i> New Job</router-link>
        </div>
    </div>
    <div v-if="showStats">
        <div class="row">
            <!-- Pending Requests Card Example -->
            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-secondary shadow h-100 px-3 py-1">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                                    New Jobs Last 7 days</div>
                                <div v-if="totalNewJobs" class="h5 mb-0 font-weight-bold text-gray-800">{{totalNewJobs}}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-star fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pending Requests Card Example -->
            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-dark shadow h-100 px-3 py-1">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-gray-700 text-uppercase mb-1">
                                    Jobs Completed Last 7 days</div>
                                <div v-if="totalCompleted" class="h5 mb-0 font-weight-bold text-gray-800">{{totalCompleted}}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-calendar-check fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-primary shadow h-100 px-3 py-1">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                    Total Active Jobs</div>
                                <div v-if="stats" class="h5 mb-0 font-weight-bold text-gray-800">{{stats.totalActive}}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-running fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-dark shadow h-100 px-3 py-1">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-gray-800 text-uppercase mb-1">
                                    Finalise / Invoice</div>
                                <div v-if="stats && stats.status['Finalise']" class="h5 mb-0 font-weight-bold text-gray-800"><span v-if="stats.status['Finalise']">{{stats.status['Finalise']}}</span><span v-else>0</span> / <span v-if="stats.status['Invoice']">{{stats.status['Invoice']}}</span><span v-else>0</span></div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-flag fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <!-- <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-info shadow h-100 p-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">Tasks
                                </div>
                                <div class="row no-gutters align-items-center">
                                    <div class="col-auto">
                                        <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">50%</div>
                                    </div>
                                    <div class="col">
                                        <div class="progress progress-sm mr-2">
                                            <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

        </div>
        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-8 col-lg-7">

                <!-- Area Chart -->
                <div class="card shadow mb-2">
                    <div class="card-body px-4 py-0">
                        <div class="charst-bar" v-if="datacollection">
                            <line-chart :options="dataOptions" :chart-data="datacollection"></line-chart>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Donut Chart -->
            <div class="col-xl-4 col-lg-5">
                <div class="card shadow mb-2">
                    <!-- Card Body -->
                    <div class="card-body px-4 py-0">
                        <div class="chafrt-area" v-if="stats">
                            <doughnut-chart :options="donutOptions" :chart-data="donutData"></doughnut-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <enquiry-table :uncompletedOnly="true"></enquiry-table>
    <job-table :statusStep="statusStep"></job-table>
</div>
</template>

<script>
import {
    db
} from '../main'

import LineChart from '@/components/LineChart.js'
import DoughnutChart from '@/components/DoughnutChart.js'
import JobTable from "@/components/JobTable";
import EnquiryTable from "@/components/EnquiryTable";

export default {
    name: "CompletedJobs",
    components: {
        JobTable,
        EnquiryTable,
        LineChart,
        DoughnutChart
    },
    data() {
        return {
            showStats: false,
            statusStep: null,
            datacollection: null,
            dataOptions: null,
            donutData: null,
            donutOptions: null,
            stats: {},
            statsByDay: null,
            completedByDay: [],
            jobsByDay: [],
            inwardsByDay: [],
            dayLabels: [],
            statusHex: [],
            totalNewJobs: 0,
            totalCompleted:0,
            statusKeysEncode:[]
        };
    },
    computed: {

    },

    mounted() {
        const t = this;
        if(localStorage.getItem('showStats')){
            t.showStats = JSON.parse(localStorage.getItem('showStats'));
        }



        db.ref('stats').on('value', snapshot => {
            t.stats = snapshot.val();
            if (t.stats && t.stats.status['Completed']) {
                delete t.stats.status['Completed'];
            }
            t.statusHex = [];
            t.statusKeysEncode = [];
            for (const [key] of Object.entries(t.stats.status)){
                t.statusKeysEncode.push(key.replace(/_/g, '/'));
                t.statusHex.push(t.$options.filters.statusHex(key));
            }
            t.fillDonutData();
            console.log(t.statusHex);

        })
        db.ref('statsByDay').limitToLast(7).on('value', snapshot => {
            t.statsByDay = snapshot.val();
            t.completedByDay = [];
            t.jobsByDay = [];
            t.inwardsByDay = [];
            t.dayLabels = [];
            snapshot.forEach(function (child) {

                var chartDate = t.$options.filters.chartDate(child.key);

                t.totalCompleted += child.val().completed;
                t.completedByDay.push({
                    t: chartDate,
                    y: child.val().completed
                });
                t.totalNewJobs += child.val().jobs;
                t.jobsByDay.push({
                    t: chartDate,
                    y: child.val().jobs
                });
                t.inwardsByDay.push({
                    t: chartDate,
                    y: child.val().inwards
                });
                t.dayLabels.push(chartDate);
            });
            console.log(t.completedByDay);
            t.fillLineData();
        })
    },

    methods: {
        showStatsChange(){
            localStorage.setItem('showStats', JSON.stringify(this.showStats));
            if(this.showStats){
                this.fillLineData();
                this.fillDonutData();
            }
        },
        fillLineData() {
            const t = this;
            this.dataOptions = {
                legend: {
                    display: true,
                    position: "bottom",
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 30,
                        bottom: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'day',
                            displayFormats: {
                                day: 'ddd, MMM D'
                            }
                        },
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Day'
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false
            }
            this.datacollection = {
                labels: t.dayLabels,
                datasets: [{
                    label: 'Jobs Created',
                    data: t.jobsByDay,
                    backgroundColor: [
                        'rgb(141, 198, 63, 0.1)',
                    ],
                    borderColor: [
                        'rgba(141, 198, 63, 1)',
                    ],
                    borderWidth: 2
                }, {
                    label: 'Inwards Recorded',
                    data: t.inwardsByDay,
                    backgroundColor: [
                        'rgba(54, 185, 204, 0.1)',
                    ],
                    borderColor: [
                        'rgba(54, 185, 204,1)',
                    ],
                    borderWidth: 2
                }, {
                    label: 'Jobs Completed',
                    data: t.completedByDay,
                    backgroundColor: [
                        'rgba(44, 44, 44, 0.1)',
                    ],
                    borderColor: [
                        'rgba(44, 44, 44,1)',
                    ],
                    borderWidth: 2
                }]
            }
        },
        fillDonutData() {
            const t = this;
            this.donutData = {
                labels: t.statusKeysEncode,
                datasets: [{
                    backgroundColor: t.statusHex,
                    data: Object.values(t.stats.status)
                }]
            }
            this.donutOptions = {

                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        boxWidth: 14
                    },
                    title: {
                        display: true,
                        text: 'Custom Chart Title',
                        position: 'bottom'
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 40,
                        bottom: 40
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 65
            }
         
        }
    },
};
</script>
